import type { Task } from '~/types/models';

const completeResponseStatuses = new Set(['completed', 'submitted', 'reviewed']);

export function normalizeClientResponseStatus(task: Pick<Task, 'clientResponseStatus'>): string {
    return String(task.clientResponseStatus || '').trim().toLowerCase();
}

export function isClientResponseComplete(task: Pick<Task, 'clientResponseStatus'>): boolean {
    return completeResponseStatuses.has(normalizeClientResponseStatus(task));
}

export function isPendingClientTaskWork(task: Pick<Task, 'clientResponseRequired' | 'clientResponseStatus' | 'clientResponseText' | 'clientResponseThread'>): boolean {
    if (task.clientResponseRequired !== true) return false;
    if (isClientResponseComplete(task)) return false;

    const normalizedStatus = normalizeClientResponseStatus(task);
    if (normalizedStatus === 'draft' || normalizedStatus === 'in_progress') {
        return true;
    }

    if (normalizedStatus === 'waiting') {
        const thread = Array.isArray(task.clientResponseThread) ? task.clientResponseThread : [];
        const latest = thread.at(-1);
        return latest?.authorType !== 'client';
    }

    return String(task.clientResponseText || '').trim().length === 0;
}

export function clientResponseStatusLabel(task: Pick<Task, 'clientResponseStatus'>): string {
    const normalizedStatus = normalizeClientResponseStatus(task);
    if (normalizedStatus === 'completed' || normalizedStatus === 'submitted') return 'Ready for review';
    if (normalizedStatus === 'reviewed') return 'Reviewed';
    if (normalizedStatus === 'draft' || normalizedStatus === 'in_progress') return 'In progress';
    return 'Not started';
}
